// extracted by mini-css-extract-plugin
export var label = "_8n-1";
export var reminder = "_8n-0";